export default __webpack_public_path__ + "static/media/psl.b8f44628.cjs";